import { cloneDeep, defaultsDeep } from 'lodash'

import { Services, empty } from '@sigma-frontend-libs/commons'

import { SENDERNAMES_FILTER, serviceTemplate } from '@/utils'

import { errorProcessorHandler } from '@/components/services/sendernames/utils'

export default {
  computed: {
    canGetSendernames() {
      return this.checkPermissions(`advanced.${Services.sendernames}.get`, 'me')
    }
  },

  mixins: [
    serviceTemplate({
      serviceName: Services.sendernames,

      inputFilter(result) {
        if (!result.OwnerId) {
          result.OwnerId = result?.Owner?.id
        }

        return defaultsDeep(result, empty.sendernames.entity)
      },

      find: {
        defaultFilter: cloneDeep(SENDERNAMES_FILTER),
        defaultOrder: { updatedAt: 'desc' }
      },

      width: 440,
      titlePath: 'name',

      has: {
        clone: false,
        source: true
      },

      formClass: '',
      errorProcessor: errorProcessorHandler,

      mounted() {
        if (this.canGetSendernames) {
          this.restData[Services.sendernames].find.filter.$scope = [ 'full', 'attached' ]
        }
      }
    })
  ],

  mounted() {
    this.handleCreateMode()
  },

  methods: {
    handleCreateMode() {
      if (this.$route.query?.mode === 'create') {
        this.showCreateDialog = true

        this.$router.replace({
          query: {
            ...this.$route.query,
            mode: undefined
          }
        })
      }
    }
  }
}
